import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';

export default function CategoryTabs() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
            漫画分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => {
            const count = cat.id === 'all' ? comics.length : comics.filter((c) => c.category === cat.id).length;
            return (
              <Link
                key={cat.id}
                to={cat.id === 'all' ? '/category/all' : `/category/${cat.slug}`}
                className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-all cursor-pointer border border-transparent hover:border-primary-200"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 text-foreground-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">{count}部</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}